if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
  document.body.classList.add('ios');
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary && summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  setTimeout(() => {
    elementToFocus.focus();
  })
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    if (video && video.contentWindow) {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    }
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    if (video && video.contentWindow) {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  });
  document.querySelectorAll('video:not([data-autoplay-video-id])').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details:not(.mega-menu[open])');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function imageLazyLoader(images) {
  images.forEach((image) => {
    if (image.classList.contains('lazy-loading')) {
      const img = new Image();
      img.srcset = image.dataset.srcset;
      img.onload = () => {
        image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        image.classList.remove('lazy-loading');
      };
    }
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity-button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity-button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details:not(.accordion-details[open])');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);

    const summaryElement = openDetailsElement.querySelector('summary');
    summaryElement.setAttribute('aria-expanded', false);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      if (detailsElement.classList.contains('accordion-details') === false) {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (!summaryElement.getAttribute('data-trap-disabled')) {
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    document.body.addEventListener('keyup', (event) => {
      const isOpenModal = this.hasAttribute('open');
      if (event.code.toUpperCase() === 'ESCAPE' && isOpenModal) this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    setTimeout(() => {
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }, 300);
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button:not(.btn-autoplay-video)');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter-current');
    this.pageTotalElement = this.querySelector('.slider-counter-total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.detectiOS();
  }

  detectiOS() {
    // Detect if the user's device is an iOS device, this is to disable custom scrollbars, and iOS 14 and above doesn't support them.
    let isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // If the user's device is iOS, add the ios class to the overflow scroller.
    if(isIOS) {
      this.classList.add('is-ios');
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // Get product variants data
    this.getVariantData();

    // Get product options data
    this.getProductOptionsData();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    this.removeErrorMessage();
    this.updateVariantLabel();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
    }
  }

  getQty() {
    const inventory = document.getElementById(`Variant-Quantity-${this.dataset.section}`);
    const selectedVariantQuantity = this.getSelectedVariantQuantity();
    let inventoryHtml = `Limited Quantity Available.`;

    if (selectedVariantQuantity > 0 && selectedVariantQuantity <= 10) {
      inventory.classList.remove('hidden');
      inventory.textContent = inventoryHtml;
    }  else {
      inventory.classList.add('hidden');
      inventory.textContent = ''; // This clears the content
    }
  }

  updateShippingMessage() {
    // Update the shipping info for the selected variant
    const selectedVariantShippingInfo = this.getSelectedVariantShippingInfo();
    const shippingInfoElement = document.querySelector('.shipping-info');

    if (shippingInfoElement && selectedVariantShippingInfo) {
      shippingInfoElement.innerHTML = `<p data-variant-metafield-id="${this.currentVariant.id}" class="paragraph-sm">${selectedVariantShippingInfo}</p>`;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('input[type="radio"]'), (select) => select.value);
  }

  updateMasterId() {
    const selectedOptions = document.querySelectorAll(`#ProductInfo-${this.dataset.section} input[type=radio]:checked`);
    if (selectedOptions && selectedOptions.length) {
      const selectedOptionsValues = Array.from(selectedOptions, (option) => option.value);
      this.currentVariant = this.variantData.find((variant) => {
        if (variant.option3) {
          return variant.option1 === selectedOptionsValues[0] && variant.option2 === selectedOptionsValues[1] && variant.option3 === selectedOptionsValues[2];
        } else if (variant.option2)  {
          return variant.option1 === selectedOptionsValues[0] && variant.option2 === selectedOptionsValues[1];
        } else {
          return variant.option1 === selectedOptionsValues[0];
        }
      });
    } else if (this.variantData.length) {
      this.currentVariant = this.variantData[0];
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal-content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantLabel() {
    const selectedSwatchLabel = this.querySelectorAll('.product-form-selected')
    selectedSwatchLabel.forEach((item) => {
      let optionPosition = item.getAttribute('data-position') - 1;
      let variantName = this.currentVariant.options[optionPosition];

      item.innerHTML = variantName;
    })
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  /**
   * Pulls variants data for this product from a script tag that must be nested inside of the web component.
   * @returns {Object} Shopifys product.variants object for this product
   * @see https://shopify.dev/api/liquid/objects/product#product-variants
   */
  getVariantData() {
    const jsonProductVariantsElement = this.querySelector('#json-product-variants[type="application/json"]');
    const jsonProductVariantMetafieldsElement = this.querySelector('#json-product-metafields[type="application/json"]');
    const jsonProductVariantQtyElement = this.querySelector('#json-product-qty[type="application/json"]');

    // Initialize an empty array for metafield values
    let metafieldValues = [];
    let inventoryValues = [];

    // Check if jsonProductVariantMetafieldsElement is not null before accessing textContent
    if (jsonProductVariantMetafieldsElement && jsonProductVariantMetafieldsElement.textContent) {
      const jsonProductVariantMetafields = JSON.parse(jsonProductVariantMetafieldsElement.textContent);

      // Check if jsonProductVariantMetafields is not null before splitting
      if (jsonProductVariantMetafields) {
        metafieldValues = jsonProductVariantMetafields.split('\n').filter(value => value !== '');
      }
    }

     // Check if jsonProductVariantQtyElement is not null before accessing textContent
     if (jsonProductVariantQtyElement && jsonProductVariantQtyElement.textContent) {
      const jsonProductVariantQty = JSON.parse(jsonProductVariantQtyElement.textContent);

      // Check if jsonProductVariantMetafields is not null before splitting
      if (jsonProductVariantQty) {
       inventoryValues = jsonProductVariantQty.split('\n').filter(value => value !== '');
      }
    }

    if (!this.variantData && jsonProductVariantsElement) {
      // Parse the JSON and map each variant to include the metafields
      this.variantData = JSON.parse(jsonProductVariantsElement.textContent).map((variant, index) => {
        // Access metafields within each variant
        const metafields = metafieldValues.length > 0 ? {
          shipping_info: metafieldValues[index] || '' // Fallback to an empty string if index is out of bounds
          // Add more metafields here if needed
        } : {};

        const variantQuantity = inventoryValues.length> 0 ? {
          quantity: inventoryValues[index] || '' // Fallback to an empty string if index is out of bounds
        } : {};
        // Return a new object that includes the metafields, else return the variant
        return {
          ...variant,
          variantQuantity: variantQuantity,
          metafields: metafields,
        };
      });
    }

    return Array.isArray(this.variantData) ? this.variantData : [];
  }

  /**
   * Pulls options data for this product from a script tag that must be nested inside of the web component.
   * @returns {Object} Shopifys product.options object for this product
   * @see https://shopify.dev/api/liquid/objects/product#product-options
   */
  getProductOptionsData() {
    const jsonProductOptions = this.querySelector('#json-product-options[type="application/json"]');
    if(!this.productOptions && jsonProductOptions !== null) {
      this.productOptions = JSON.parse(jsonProductOptions.textContent);
    }
    return Array.isArray(this.productOptions) ? this.productOptions : [];
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    // Status Classes
    this.statusClasses = {
      unavailable: 'unavailable',
      outOfStock: 'out-of-stock',
    }

    // Swatches
    this.options = /** @type {HTMLInputElement[]} */ (Array.from(this.querySelectorAll('input[type="radio"]')));

    // Set initial swatches state when the page loads
    this.initialOptionState();
  }

  /**
   * Pull the values from currently selected swatches (product options) in <variant-radios>
   */
  updateOptions(event) {
    if (event && event.target) {
      const target = event.target;
      const optionType = target.getAttribute('name');
      const optionValue = target.value;

      const allOptionsOfType = document.querySelectorAll(`input[name="${optionType}"]`);
      allOptionsOfType.forEach((option) => {
        if (option.value.toString() === optionValue.toString()) {
          option.setAttribute('checked', '');
        } else {
          option.removeAttribute('checked');
        }
      });
    }
  }

  /**
   * Event Handler: Change
   * @param {Object} event The change event interface emitted from to the radio button's event listener.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event
   */
  onVariantChange(event) {

    // Update currently selected product options that the methods of this component reference internally
    this.updateOptions(event);

    // Update the currently selected variant id that the methods of this component reference internally
    this.updateMasterId();

    // Update the browsers URL to the newly selected variant
    this.updateURL();

    // Update variant inventory
    this.getQty();

    // Update variant shipping message
    this.updateShippingMessage();

    // AJAX request to refresh content using the section rendering API.
    //this.refreshProductDetails();

    // Update <product-form> with the correct values for the selected variant, ensuring "Add to Cart" adds the correct variant/options
    this.updateVariantInput();

    // Update the <media-gallery> web component
    this.updateMedia();

    // Update the swatch-option-label to display the name of the selected swatch in a group of swatches
    this.updateVariantLabel();

    // Update the state of the swatch images to show availability
    this.updateOptionState(event);

    // Emit the newly selected variant to other web components on the PDP page
    this.emitVariantChange({
      ...this.currentVariant,
      statusClasses: this.statusClasses
    });
  }

  /**
   * Emits the variantChange event
   *
   * When a user changes the variant by choosing a swatch, this event fires to trigger updates in other web components on the page.
   * Other web components have event listeners set-up that listen for this variantChange event, so each web component is responsible for updating itself.
   * @param {Object} detail The detail object can contain additional data that other web components can use.
   * @event variantChange
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail
   */
  emitVariantChange(detail) {
    this.dispatchEvent(new CustomEvent('variantChange', {detail}));
  }

  /**
   * Update the state of all swatches after a variant change
   *
   * This function is responsible for indicating if a swatch is unavailable or out of stock. The swatches
   * are radio buttons in the DOM, modified to appear as selectable swatches.
   */
  updateOptionState() {
    // Reset swatch state
    this.resetOptionState();

    // If the 1st option is not available for all variants, add the outOfStock class to that radio option.
    this.options.filter(option => option.dataset.optionIndex === '1').forEach(option => {
      const optionInStock = this.variantData.filter(variant => variant.options.includes(option.value) && variant.available);
      if (!optionInStock.length) {
        option.classList.add(this.statusClasses.outOfStock);
      }
    });

    // If the 2nd option is not available for all variants, add the outOfStock class to that radio option.
    const optionIndex2Options = this.options.filter(option => option.dataset.optionIndex === '2');
    if (optionIndex2Options.length) {
      const selectedOption1 = this.currentVariant.option1 ? this.currentVariant.option1 : '';
      const selectedOption2 = this.currentVariant.option2;
      const selectedOption3 = this.currentVariant.option3 ? this.currentVariant.option3 : selectedOption2;

      optionIndex2Options.forEach((option) => {
        const unavailableVariants = this.variantData.filter((variant) => {
          if (selectedOption3 !== selectedOption2) {
            return variant.options.includes(selectedOption1) &&
              variant.options.includes(option.value) &&
              variant.options.includes(selectedOption3) &&
              !variant.available;
          } else {
            return variant.options.includes(selectedOption1) &&
              variant.options.includes(option.value) &&
              !variant.available;
          }
        });

        if (unavailableVariants.length >= 1) {
          option.classList.add(this.statusClasses.outOfStock);
        }
      });
    }

    // If the 3rd option is not available for all variants, add the outOfStock class to that radio option.
    const optionIndex3Options = this.options.filter(option => option.dataset.optionIndex === '3');
    if (optionIndex3Options.length) {
      const selectedOption1 = this.currentVariant.option1;
      const selectedOption2 = this.currentVariant.option2;

      optionIndex3Options.forEach((option) => {
        const unavailableVariants = this.variantData.filter((variant) => {
          return variant.options.includes(selectedOption1) &&
            variant.options.includes(selectedOption2) &&
            variant.options.includes(option.value) &&
            !variant.available;
        });

        if (unavailableVariants.length >= 1) {
          option.classList.add(this.statusClasses.outOfStock);
        }
      });
    }
  }

  /**
   * Re-renders the product details section when the variant changes on the PDP page
   * @see https://shopify.dev/api/section-rendering
   */

   refreshProductDetails() {
    const productDetailsSection = document.querySelector('.product-details-wrapper');
    if(productDetailsSection !== null && typeof productDetailsSection.id === 'string' && this.currentVariant !== undefined && typeof this.currentVariant.id === 'number') {
      fetch(`${window.location.pathname}?variant=${this.currentVariant.id}&section_id=${productDetailsSection.getAttribute('data-section')}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(productDetailsSection.id);
        const source = html.getElementById(productDetailsSection.id);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
    }
  }

  getSelectedVariantShippingInfo() {
    // Get the shipping info for the selected variant from your variant data
    const selectedVariant = this.variantData.find((variant) => variant.id === this.currentVariant.id);

    if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields) {
      return selectedVariant.metafields.shipping_info;
    }
  }

  getSelectedVariantQuantity() {
    // Get the variant quantity from json data
    const selectedVariant = this.variantData.find((variant) => variant.id === this.currentVariant.id);

    if (selectedVariant && selectedVariant.variantQuantity && selectedVariant.variantQuantity) {
      return selectedVariant.variantQuantity.quantity;
    }
  }

  /**
   * Initial swatch state
   *
   * When this web component is constructed, set the initial availability state based on the currently selected options.
   *
   * This method fires a "mock" event as though the user clicked on a swatch, it will pull the data for the :checked swatch
   * for the provided optionIndex, and fire the change event as if that swatch were clicked to update the availability of
   * the other swatches on page load.
   *
   * @param {Number} optionIndex The option position/index for the fieldset of swatches you want to "mock" the change event for.
   * @see https://shopify.dev/api/liquid/objects/product_option#product_option-position
   */
  initialOptionState(optionIndex) {
    // Initial data set-up
    this.updateOptions();
    this.updateMasterId();
    this.updateOptionState();
  }

  /**
   * Removes all status classes from every option, such as out of stock or unavailable classes.
   */
  resetOptionState() {
    if (this.options && this.options.length > 0) {
      this.options.forEach(option => {
        Object.values(this.statusClasses).forEach(status => option.classList && option.classList.remove(status));
      })
    }
  }
}

customElements.define('variant-radios', VariantRadios);

/**
 * PDP Price
 *
 * The <pdp-price> web component is responsible for rendering prices on the PDP page. More specifically,
 * it has event listeners automatically binded to it in order to respond to the 'variantChange' event that
 * fires when the <variant-radios> component changes the currently selected variant on the PDP page.
 *
 * @extends HTMLElement
 */
class PDPPrice extends HTMLElement {
  constructor() {
    super();
    // Set-up event listener to listen for change event in <variant-radios>
    const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`)
    if(variantRadios) {
      variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
    }
    this.getCurrencyData();
    this.salePrice = this.querySelectorAll('.price-item.price-item-sale');
    this.regularPrice = this.querySelectorAll('.price-item.price-item-regular');
    this.proDiscount = this.currencyData.pro_discount && !Number.isNaN(Number(this.currencyData.pro_discount)) && Number(this.currencyData.pro_discount) < 1 ? Number(this.currencyData.pro_discount) : 1;
    this.proCustomer = this.proDiscount < 1;
    this.eligibleForProDiscount = this.currencyData.product_eligible_for_pro_discount === 'true' && this.currencyData.show_pro_discount === 'true';
   }

  /**
   * variantChange event handler
   * @param {Object} e The variantChange custom event interface emitted from the <variant-radios> web component.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
   */
  onVariantChange(e) {
    const {compare_at_price, price} = e.detail;
    const on_sale = compare_at_price !== null && compare_at_price > price;
    const regular_price = on_sale ? compare_at_price : price;
    // Update all sale price elements
    this.salePrice.forEach(salePrice => {
      salePrice.innerText = this.proCustomer && this.eligibleForProDiscount ? this.formatPrice(regular_price * this.proDiscount) : this.formatPrice(price);
    });
    // Update all regular price elements
    this.regularPrice.forEach(regularPrice => {
      regularPrice.innerText = this.formatPrice(on_sale ? compare_at_price : price);
    });
    // Set price class on <pdp-price> element to display on sale pricing or regular pricing
    this.setPriceClasses(e.detail)
  }

  /**
   * Adds the correct classes to the price wrapper based on whether or not the product is on sale.
   * This will show/hide the strikethrough price based on which class gets set.
   * @param {Object} variant The shopify variant object passed in the detail property in the 'variantChange' event.
   * @see https://shopify.dev/api/liquid/objects/variant
   */
  setPriceClasses(variant) {
    // Sold Out
    if(variant.available === false) {
      this.classList.add('price-sold-out');
    } else {
      this.classList.remove('price-sold-out');
    }
    // On Sale
    const on_sale = variant.compare_at_price !== null && variant.compare_at_price > variant.price;
    if(on_sale) {
      this.classList.add('price-on-sale');
    } else if(this.proCustomer === true && this.eligibleForProDiscount === true) {
      this.classList.add('price-on-sale');
    } else {
      this.classList.remove('price-on-sale');
    }
  }

  /**
   * Get currency and money format data
   * @returns {Object} The JSON passed in the #json-currency-data script tag inside of the <pdp-price> web component.
   */
  getCurrencyData() {
    this.currencyData = this.currencyData || JSON.parse(this.querySelector('#json-currency-data[type="application/json"]').textContent);
    return this.currencyData;
  }

  /**
   * Format a price string
   * @param {Number|String} price Should be product.price or product.compare_at_price
   * @see https://shopify.dev/api/liquid/objects/product#product-compare_at_price
   * @see https://shopify.dev/api/liquid/objects/product#product-price
   * @see https://shopify.dev/api/liquid/filters/money
   * @see https://shopify.dev/api/liquid/filters/money_with_currency
   * @returns {String} A formatted price string that has shopifys money format filters applied to it.
   */
  formatPrice(price) {
    const {currency_code_enabled, money_format, money_with_currency_format} = this.currencyData;
    const options = {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };
    const formatted_price = new Intl.NumberFormat(window.Shopify.locale, options).format(Number(price) / 100);
    const shopify_format = currency_code_enabled ? money_with_currency_format : money_format;
    return shopify_format.replace('{{amount}}', formatted_price);
  }
}

customElements.define('pdp-price', PDPPrice);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}